import { useRedirectToWhenSignedOut } from '@spa/scenes/Auth/shared/services/authState/hooks/useRedirectToWhenSignedOut'
import React from 'react'
import { Navigate } from 'react-router-dom'

export const GuestAppRedirects = () => {
  const url = useRedirectToWhenSignedOut()

  return <Navigate to={url} />
}
